import AppActions from 'bukku/redux/App/actions';
import dayjs from 'dayjs';
import { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppModalType } from '../../../../../enums/AppModalType';
import { CookieKey } from '../../../../../enums/CookieKey';
import { MomentFormatEnums } from '../../../../../enums/MomentEnums';
import { CookiesHelper } from '../../../../../helpers/CookiesHelper';
import { usePrevious } from '../../../../../helpers/useReadStateSuccess';
import { isDebugIdleModal, POLLING_INTERVAL_MILLISECONDS } from '../../constants';

const {
    openAppModal,
    closeAppModal,
} = AppActions;

const selectorFn = state => ({
    isIdleModalVisible: state.App.appModal[AppModalType.IDLE_MODAL].isVisible,
    isExpiredModalVisible: state.App.appModal[AppModalType.SESSION_EXPIRED_MODAL].isVisible,
    isSessionLockEnabled: state.User.user?.session_idle_lock,
});

/**
 * A function to check if user is idle or not by comparing session_idle_expiry_time cookie with current time
 * will poll every time interval set in POLLING_INTERVAL_MILLISECONDS (2 hours)
 * - also handles session_idle_lock change in user profile
 * @param {Function} resetCookieAndCloseModal
 */
export const useIdlePollingTimer = resetCookieAndCloseModal => {
    const dispatch = useDispatch();
    const {
        isIdleModalVisible,
        isExpiredModalVisible,
        isSessionLockEnabled,
    } = useSelector(selectorFn, shallowEqual);

    const handleIdleState = useCallback(() => {
        // check difference between lastApiCallTime and current time
        const idleTimeoutTime = CookiesHelper.getCookie(CookieKey.session_idle);
        const diff = dayjs(idleTimeoutTime).diff(dayjs(), 'second');
        const isIdle = diff <= 0;

        if (idleTimeoutTime) {
            if (isDebugIdleModal) {
                console.log('aaa debug Inactive Modal V2 - usePollingTimer', {
                    // timer,
                    diff,
                    idleTimeoutTime,
                    timeNow: dayjs().format(MomentFormatEnums.date_time),
                    isIdle: diff <= 0,
                    isIdleModalVisible,
                    isExpiredModalVisible,
                    visibilityState: document.visibilityState,
                });
            }

            // if (isIdle && !isIdleModalVisible && !isExpiredModalVisible)
            if (document.visibilityState === 'visible' && isIdle && !isIdleModalVisible && !isExpiredModalVisible)
                dispatch(openAppModal(AppModalType.IDLE_MODAL));

            if (!isIdle && isIdleModalVisible) {
                console.log('CLOSE IDLE MODAL AT TIME ', dayjs().format(MomentFormatEnums.date_time));
                dispatch(closeAppModal(AppModalType.IDLE_MODAL));
            }
        }
    }, [dispatch, isIdleModalVisible, isExpiredModalVisible]);

    const prevIsSessionLockEnabled = usePrevious(isSessionLockEnabled);
    useEffect(() => {
        let timer;

        // 1. TIMER - When session_idle_lock is true, the interval polling will start
        if (isSessionLockEnabled) {
            timer = setInterval(() => {
                handleIdleState();
            }, POLLING_INTERVAL_MILLISECONDS);

            // Event Listener for visibility change (eg: tab visible / hidden)
            // In case idle/revalidated when change tabs
            // while next polling cycle is not yet reached
            // --> eg polling of 60 sec will have delay when it is still at 1st-59th sec
            document.addEventListener('visibilitychange', handleIdleState);
        }

        // 2. SESSION_IDLE_LOCK - Handle change in User Profile
        // If user enable session_idle_lock, set cookie
        if (isSessionLockEnabled && prevIsSessionLockEnabled === false) {
            if (isDebugIdleModal)
                console.log('aaa debug InactiveModalV2 - useIdlePollingTimer - set cookie');
            resetCookieAndCloseModal();
        }
        // If user disable session_idle_lock, clear interval
        else if (!isSessionLockEnabled && prevIsSessionLockEnabled === true) {
            if (isDebugIdleModal)
                console.log('aaa clear Timer', timer);
            clearInterval(timer);
        }

        return () => {
            clearInterval(timer);
            document.removeEventListener('visibilitychange', handleIdleState);
        };
    }, [isSessionLockEnabled, prevIsSessionLockEnabled, resetCookieAndCloseModal, handleIdleState]);
};
